import {TUTORIAL_PROGRESS_EVENT} from '../constants';

function notifyTutorialProgressChange() {
	window.dispatchEvent(new Event(TUTORIAL_PROGRESS_EVENT));
}

export {notifyTutorialProgressChange};
